import api from "@/services/api";
import type {
	EventsListParams,
	EventsPaginatedResponse,
} from "../types/events";

function buildEventsSearchParams(params: EventsListParams): URLSearchParams {
	const {
		startDate,
		endDate,
		search,
		types,
		isDriver,
		pageNumber,
		pageSize,
		sortBy,
		sortDirection,
	} = params;

	const searchParams = new URLSearchParams({
		PageNumber: String(pageNumber),
		PageSize: String(pageSize),
	});

	if (startDate) {
		searchParams.append("StartDate", startDate);
	}

	if (endDate) {
		searchParams.append("EndDate", endDate);
	}

	if (search?.trim()) {
		searchParams.append("Search", search.trim());
	}

	if (types?.length) {
		for (const typeCode of types) {
			searchParams.append("Types", String(typeCode));
		}
	}

	if (isDriver !== undefined) {
		searchParams.append("IsDriver", String(isDriver));
	}

	if (sortBy) {
		searchParams.append("SortBy", sortBy);
	}

	if (sortDirection) {
		searchParams.append("SortDirection", sortDirection);
	}

	return searchParams;
}

export async function getEvents(
	params: EventsListParams
): Promise<EventsPaginatedResponse> {
	const searchParams = buildEventsSearchParams(params);

	const { data } = await api.get<EventsPaginatedResponse>("/api/event", {
		params: searchParams,
	});

	const pageSize = data.pageSize ?? params.pageSize;
	const totalCount = data.totalCount ?? 0;
	const currentPage = data.currentPage ?? params.pageNumber;
	const totalPages =
		data.totalPages ?? Math.max(1, Math.ceil(totalCount / pageSize));

	return {
		items: data.items ?? [],
		totalCount,
		pageSize,
		currentPage,
		totalPages,
	};
}
